import { Type } from 'class-transformer'
import type { ReportType } from '@/constants/schema-constants'
import { Material } from '@/dtos/commons'

export class ReportFilesPostDto {
  oldFileName!: string
  @Type(() => Material) material!: Material
}

export class ReportFilesPostRequest {
  reportFiles!: ReportFilesPostDto[]
  reportType!: ReportType
  targetYearMonth!: string
  uploadOrder!: number
  constructor(reportFiles: ReportFilesPostDto[], reportType: ReportType, targetYearMonth: string, uploadOrder: number) {
    this.reportFiles = reportFiles
    this.reportType = reportType
    this.targetYearMonth = targetYearMonth
    this.uploadOrder = uploadOrder
  }
}

export class ErrorFilesDto {
  errorMessage?: string[]
  errorFileNameList?: string[]
}

export class ReportFilesPostResponse {
  errors?: ErrorFilesDto[]
}
